<template>
	<div :class="`posts-container type-${viewType}`">
		<div class="parent-title-container" v-if="(featureSet.postsView.parentCategoryTitle && parentCategory)">
			<h1 class="heading-big">
				{{ parentCategory.title[language] }}
			</h1>
		</div>
		<div class="title-container" v-if="featureSet.postsView.titleDecoration">
			<template v-if="!(featureSet.postsView.hideTitle.all || (featureSet.postsView.hideTitle.children && category.parent_id !== null))">
				<img class="title-decoration" src="/storage/static/LAsset.png"/>
				<h1 class="heading-big">
					{{this.category.title[language]}}
				</h1>
				<img class="title-decoration" src="/storage/static/RAsset.png"/>
			</template>
		</div>
		<template v-else>
			<h1 v-if="!(featureSet.postsView.hideTitle.all || (featureSet.postsView.hideTitle.children && category.parent_id !== null))" class="heading-big">{{this.category.title[language]}}</h1>
		</template>
		<template v-if="category.page_id">
			<PageView :id="Number(category.page_id)" :no-title="true"/>
		</template>
		<div class="category-thumbnails-container" v-if="childrenCategories.length > 0">
			<CategoryThumbnail v-for="c in childrenCategories" :key="c.id" :title="c.title[language]" :image="c.background_image" :id="c.id" />
		</div>
		<template  v-if="allCategoryPosts.length > 0">
			<template v-if="viewType === 'tab'">
				<TabContentThumbnail :posts="allCategoryPosts" :language="language" />
			</template>
			<template v-else-if="viewType === 'note'">
				<template v-if="featureSet.postsView.separateByYears && featureSet.postsView.separateCategoryType.note">
					<div v-for="(year, index) in categoryYears" :key="index">
						<h2 :id="`${year}`" class="separate-by-year">{{year}}</h2>
						<template v-for="(post, index) in allCategoryPosts">
							<NoteContentThumbnail
								:scrollToId="closestPost"
								v-if="post.year === year"
								:id="post.id"
								:title="post.title[language]"
								:content="post.body[language]"
								:key="index"
								:date="post.date"
								:link_text="post.link_text[language]"
								:link_url="post.link_url" />
						</template>
					</div>
				</template>
				<template v-if="!featureSet.postsView.separateByYears">
					<template v-for="(post, index) in allCategoryPosts">
						<NoteContentThumbnail
							:scrollToId="closestPost"
							:id="post.id"
							:title="post.title[language]"
							:content="post.body[language]"
							:key="index"
							:date="post.date"
							:link_text="post.link_text[language]"
							:link_url="post.link_url" />
					</template>
				</template>
			</template>
			<template v-else-if="viewType === 'accordion'">
				<AccordionView :accid="category.id" />
			</template>
			<div :class="`${viewType}-container`" v-else>
				<template v-if="featureSet.postsView.separateCategoryType[viewType]">
					<div v-for="(year, index) in categoryYears" :key="index">
						<h2 :id="`${year}`" class="separate-by-year">{{year}}</h2>
						<template v-for="(post, index) in allCategoryPosts">
							<ContentThumbnail
								:id="post.id"
								:title="post.title[language]"
								:content="post.body[language]"
								:image="post.cover_image"
								type="post"
								:key="index"
								:date="post.date"
								:link_text="post.link_text[language]"
								:link_url="post.link_url"
								:view="viewType" />
						</template>
					</div>
				</template>
				<template v-if="!featureSet.postsView.separateCategoryType[viewType]">
					<template v-for="(post, index) in allCategoryPosts">
						<ContentThumbnail
						:id="post.id"
						:title="post.title[language]"
						:content="post.body[language]"
						:image="post.cover_image"
						type="post"
						:key="index"
						:date="post.date"
						:link_text="post.link_text[language]"
						:link_url="post.link_url"
						:view="viewType" />
					</template>
				</template>
			</div>
		</template>
		<div v-if="featureSet.postsView.image" class="posts-category-image">
			<img :src="`/storage/media/${categoryImage}`" alt="">
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import PageView from '@/views/PageView.vue';
import ContentThumbnail from '@/components/ContentThumbnail.vue';
import CategoryThumbnail from '@/components/CategoryThumbnail.vue';
import TabContentThumbnail from '@/components/TabContentThumbnail.vue';
import NoteContentThumbnail from '@/components/NoteContentThumbnail.vue';
import AccordionView from '@/components/AccordionView.vue';
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';
import propIdMixin from './prop-id-mixin';
import contentParserMixin from './content-parser-mixin';

export default {
	name: 'PostsView',
	mixins: [propIdMixin, contentDataLoaderMixin, staticDataLoaderMixin, featureSetLoaderMixin, contentParserMixin],
	props: {
		view: {
			type: [String],
			validator(d) {
				return typeof d === 'string';
			},
			required: false,
		},
		limit: [Boolean],
		homePage: [Boolean],
	},
	components: {
		PageView,
		ContentThumbnail,
		TabContentThumbnail,
		NoteContentThumbnail,
		CategoryThumbnail,
		AccordionView,
	},
	data() {
		return {
			viewType: this.view ? this.view : false,
			contentType: 'category',
			containerClass: 'category-container',
			contentClass: 'category-content',
		};
	},
	updated() {
		this.updateImages();
	},
	created() {
		this.$emit('alt-background', false);
		this.updateImages();
		// set view type if it's not set
		if (!this.viewType) this.viewType = this.category.view;

		this.setTitle(`${this.category.title[this.language]} - ${this.$store.state.cName}`);
	},
	methods: {
		...mapActions('title', ['setTitle']),
		updateImages() {
			if (this.category.background_image && !this.homePage) {
				const media = this.findInMedia(this.category.background_image);
				if (media) {
					this.$root.$emit('updateCoverImages', [media.original_name]);
				}
			} else {
				this.$root.$emit('resetCoverImages');
			}
		},
	},
	computed: {
		closestPost() {
			const now = new Date();
			let closest = Infinity;
			let closestPostId = null;
			this.allCategoryPosts.forEach((p) => {
				const date = new Date(p.date);
				if (date >= now && (date < new Date(closest) || date < closest)) {
					closest = p.date;
					closestPostId = p.id;
				}
			});
			return closestPostId;
		},
		allCategoryPosts() {
			const allPosts = this.getContent('posts');
			allPosts.forEach((e) => {
				e.year = moment(e.date).year();
				if (!e.link_text) {
					e.link_text = this.languageList.map((l) => {
						const langName = l.name;
						return { [langName]: '' };
					});
				}
			});
			const filteredPosts = allPosts.filter(e => Number(e.category_id) === this.pid)
				.sort((a, b) => {
					const calc = moment(a.date).isBefore(moment(b.date));
					return calc ? 1 : -1;
				});

			if (this.limit) {
				return filteredPosts.slice(0, (filteredPosts.length >= 10 ? 10 : filteredPosts.length));
			}
			return filteredPosts;
		},
		category() {
			return this.categories.find(e => e.id === this.pid);
		},
		parentCategory() {
			return this.categories.find(e => e.id === this.category.parent_id);
		},
		categoryYears() {
			const yearArray = [];
			this.allCategoryPosts.forEach((e) => {
				if (e.date) {
					if (yearArray.indexOf(e.year) === -1) {
						yearArray.push(e.year);
					}
				}
			});
			if (this.limit) {
				return [yearArray[0]];
			}

			return yearArray;
		},
		categoryImage() {
			const media = this.findInMedia(this.category.background_image);
			if (media) {
				return media.original_name;
			}
			return false;
		},
		childrenCategories() {
			return this.categories.filter(c => c.parent_id === this.category.id);
		},
	},
};
</script>

<style src="@/styles/views/PostsView/PostsView.less" lang="less" scoped></style>
